var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsOptional, IsString, IsUrl, MaxLength, ValidateIf, } from 'class-validator';
const HTTPS_URL = { protocols: ['https'], require_protocol: true };
const URL_MESSAGE = 'https:// 로 시작하는 주소를 입력해 주세요.';
const isFilled = (_, value) => value !== undefined && value !== '';
/**
 * Customer-service contact and messenger links of a D2C site (`profile.contact`).
 * An empty string means the site does not show that item.
 */
export class D2CSiteContactProfile {
}
__decorate([
    IsOptional(),
    IsString(),
    MaxLength(50),
    __metadata("design:type", String)
], D2CSiteContactProfile.prototype, "csPhone", void 0);
__decorate([
    IsOptional(),
    IsString(),
    MaxLength(100),
    __metadata("design:type", String)
], D2CSiteContactProfile.prototype, "csHours", void 0);
__decorate([
    IsOptional(),
    IsString(),
    MaxLength(100),
    __metadata("design:type", String)
], D2CSiteContactProfile.prototype, "breakTime", void 0);
__decorate([
    ValidateIf(isFilled),
    IsUrl(HTTPS_URL, { message: URL_MESSAGE }),
    MaxLength(300),
    __metadata("design:type", String)
], D2CSiteContactProfile.prototype, "kakaoChannelUrl", void 0);
__decorate([
    ValidateIf(isFilled),
    IsUrl(HTTPS_URL, { message: URL_MESSAGE }),
    MaxLength(300),
    __metadata("design:type", String)
], D2CSiteContactProfile.prototype, "whatsappUrl", void 0);
__decorate([
    ValidateIf(isFilled),
    IsUrl(HTTPS_URL, { message: URL_MESSAGE }),
    MaxLength(300),
    __metadata("design:type", String)
], D2CSiteContactProfile.prototype, "lineUrl", void 0);
__decorate([
    ValidateIf(isFilled),
    IsUrl(HTTPS_URL, { message: URL_MESSAGE }),
    MaxLength(300),
    __metadata("design:type", String)
], D2CSiteContactProfile.prototype, "instagramUrl", void 0);
__decorate([
    ValidateIf(isFilled),
    IsUrl(HTTPS_URL, { message: URL_MESSAGE }),
    MaxLength(300),
    __metadata("design:type", String)
], D2CSiteContactProfile.prototype, "facebookUrl", void 0);
__decorate([
    ValidateIf(isFilled),
    IsUrl(HTTPS_URL, { message: URL_MESSAGE }),
    MaxLength(300),
    __metadata("design:type", String)
], D2CSiteContactProfile.prototype, "youtubeUrl", void 0);
